@if (titlePassedIn && itemsPassedIn) {
  <div class="inner-page-nav-section">
    <h2 class="inner-page-nav-title">{{ titlePassedIn }}</h2>
    <ul class="inner-page-nav-list">
      @for (item of itemsPassedIn; track item) {
        <li class="inner-page-nav-item">
          @if (!isVideoPage) {
            <a [routerLink]="item.route" class="inner-page-nav-link">{{ item.label }}</a>
          }
          @if (isVideoPage) {
            <a class="inner-page-nav-link" (click)="goToVideoRoute(item.category)">{{ item.label }}</a>
          }
        </li>
      }
    </ul>
  </div>
}